import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags'; 
import { Link } from 'react-router-dom'; // Added Meta Tag npm Package
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, UncontrolledTooltip, Badge } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import { Config, formatDate, TOAST_OPTIONS } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Select from 'react-select';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { Button} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'



    const Inventory = () => {

        toastr.options = TOAST_OPTIONS;

        const [modal_inventory, setmodal_inventory] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [inventoryList, setInventoryList] = useState([]);
        const [isloading, setIsloading] = useState(false)
        const [userId, setUserId] = useState('')

        const [itemId, setItemId] = useState('')
        const [name, setName] = useState('')
        const [count, setCount] = useState('')
        const [categoryId, setCategoryId] = useState('')
        const [description, setDescription] = useState('')
        const [sku, setSKU] = useState('')
        const [costPrice, setCostPrice] = useState('')
        const [sellPrice, setSellPrice] = useState('')
        const [supplierId, setSupplierId] = useState('')

        const [id, setId] = useState('')
        const [qtyAtHand, setQtyAtHand] = useState(0)
        const [minimumLevel, setMinimumLevel] = useState(0)
        const [reorderQty, setReorderQty] = useState(0)
        const [purchasePrice, setPurchasePrice] = useState(0)
        const [warehouseId, setWarehouseId] = useState('')
        const [expiryDate, setExpiryDate] = useState([])
        const [itemType, setItemType] = useState('')

        const [sId, setSId] = useState('')
        const [sStartDate, setSStartDate] = useState([])
        const [sEndDate, setSEndDate] = useState([])
        const [sName, setSName] = useState('')
        const [sCategoryId, setSCategoryId] = useState('')
        const [sItemType, setSItemType] = useState('')
        const [sWarehouseId, setSWarehouseId] = useState('')
        const [sSupplierId, setSSupplierId] = useState('')
        const [sRegionId, setSRegionId] = useState('')

        const [itemCategoryOptions, setItemCategoryOptions] = useState([])
        const [supplierOptions, setSupplierOptions] = useState([])
        const [warehouseOptions, setWarehouseOptions] = useState([])
        const [regionOptions, setRegionOptions] = useState([])
        const [typeOptions, setTypeOptions] = useState(['Stock Item', 'Direct Item'])
        const [countOptions, setCountOptions] = useState(['No', 'Litres', 'Kilograms', 'Pieces', 'Meters', 'Boxes', 
  'Gallons', 'Cubic Meters', 'Tons', 'Packets', 'Bags', 
  'Drums', 'Containers', 'Pallets', 'Rolls', 'Sets', 
  'Units', 'Bottles', 'Jars', 'Cartons', 'Barrels'])
        

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_inventory = () => {
          setmodal_inventory(!modal_inventory);
          removeBodyCss();
        }

        const handleFilterData = () =>{
            const data = {
                startDate: sStartDate[0]?formatDate(sStartDate[0]):'',
                endDate: sEndDate[0]?formatDate(sEndDate[0]):'',
                name: sName, 
                categoryId: sCategoryId,
                itemType: sItemType, 
                warehouseId: sWarehouseId, 
                supplierId: sSupplierId,
                regionId: sRegionId
            }

            setIsloading(true)
            axios.post(url.INVENTORYFILTER, JSON.stringify(data), Config).then((r)=>{ 
                if(r.data){
                    setInventoryList(r.data)
                }
              }).catch((e)=>{  
                console.log(e); 
              }).finally(()=>{
                setIsloading(false)
              })
         
        }
        useEffect(() => {
            if(localStorage.getItem("authWTUser")){
                const obj = JSON.parse(localStorage.getItem("authWTUser"));
                setUserId(obj.id)
            }
            axios.get(`${url.REGIONS}`, Config).then((r)=>{
                setRegionOptions(r.data)
            }).catch((e)=>{console.log(e);})
         
            axios.get(`${url.ITEMCATEGORIES}`, Config).then((r)=>{
                setItemCategoryOptions(r.data)
            }).catch((e)=>{console.log(e);})
           
            axios.get(`${url.WAREHOUSES}`, Config).then((r)=>{
                setWarehouseOptions(r.data)
            }).catch((e)=>{console.log(e);}) 
            const data = {  }
            axios.post(url.SUPPLIERFILTER, JSON.stringify(data), Config).then((r)=>{ 
                setSupplierOptions(r.data)
              }).catch((e)=>{  
                console.log(e); 
              })
            handleFilterData()
        },[]);

        const handleClickEdit = (row) => {
            setIsEdit(true)
            tog_inventory()
            setId(row.id)
            setName(row.item)
            setCount(row.count)
            setCategoryId(row.categoryId)
            setDescription(row.itemDesc)
            setSKU(row.sku)
            setExpiryDate(row.expiryDate && row.expiryDate != '0000-00-00' ? [new Date(row.expiryDate)] : []);
            setItemType(row.itemType)
            setCostPrice(row.costPrice)
            setSellPrice(row.sellPrice)
            setSupplierId(row.supplierId)
            setItemId(row.itemId)
            setQtyAtHand(row.qtyAtHand)
            setMinimumLevel(row.minimumLevel)
            setReorderQty(row.reOrderQty)
            setPurchasePrice(row.purchasePrice)
            setWarehouseId(row.warehouseId)
        }
 
        const handleClickAdd = () => {  
            setIsEdit(false);
            tog_inventory(); 
            setId('')
            setName('')
            setCount('')
            setCategoryId('')
            setDescription('')
            setSKU('')
            setItemType('')
            setCostPrice('')
            setSellPrice('')
            setSupplierId('')
            setExpiryDate('')
            setItemId('')
            setQtyAtHand('')
            setMinimumLevel('')
            setReorderQty('')
            setPurchasePrice('')
            setWarehouseId('') 
        }
        const handleSaveInventory = () =>{
            const data = {
                id: isEdit?id:'',
                name: name,
                count: count,
                categoryId: categoryId,
                description: description,
                sku: sku,
                costPrice: costPrice,
                sellPrice: sellPrice,
                supplierId: supplierId,
                expiryDate: expiryDate?formatDate(expiryDate):'',
                itemId: itemId,
                itemType: itemType,
                qtyAtHand: qtyAtHand,
                minimumLevel: minimumLevel,
                reorderQty: reorderQty,
                purchasePrice:purchasePrice,
                warehouseId: warehouseId,
                userId: userId,
                action: isEdit?'edit':'add'
            }
            setIsloading(true)
            axios.post(url.INVENTORY, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == "1"){
                    toastr.success(r.data.message)
                    tog_inventory()
                    setName('')
                    setCount('')
                    setCategoryId('')
                    setDescription('')
                    setSKU('')
                    setCostPrice('')
                    setSellPrice('')
                    setSupplierId('')
                    setItemId('')
                    setItemType('')
                    setExpiryDate([])
                    setQtyAtHand('')
                    setMinimumLevel('')
                    setReorderQty('')
                    setPurchasePrice('')
                    setWarehouseId('')
                    handleFilterData()
                }else{
                    toastr.error(r.data.message)
                }
            }).catch((e)=>{
                console.log(e)
            }).finally(()=>{
                setIsloading(false)
            })
           
        }

        const columns = [

        {
          dataField: 'item',
          text: 'Item',
          sort: true
        },
        {
            dataField: 'count',
            text: 'Units',
            sort: true
        },
        {
            dataField: 'category',
            text: 'Category',
            sort: true
          },
        {
          dataField: 'qtyAtHand',
          text: 'At Hand',
          sort: true,
          headerStyle: { textAlign: 'center' },
          style: { textAlign: 'center' } 
        },
        {
            dataField: 'costPrice',
            text: 'Cost Price',
            sort: true,
            formatter: (cell) => {
                return new Intl.NumberFormat().format(cell); 
            },
              headerStyle: { textAlign: 'right' },
              style: { textAlign: 'right' } 
          },
          {
            dataField: 'warehouse',
            text: 'Store Location',
            sort: true
          },
        {
            dataField: 'status',
            text: '',
            sort: true,
            formatter: statusFormatter
        },
        {
          dataField: "",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'id',
          order: 'asc'
        }];
        function statusFormatter(cellContent, row) {
            const qtyAtHand = parseInt(row.qtyAtHand) || 0;
            const reOrderQty = parseInt(row.reOrderQty) || 0;
            const minimumLevel = parseInt(row.minimumLevel) || 0;
          
            if (qtyAtHand === 0) {
              return <Badge className="me-2 bg-secondary">Out of Stock</Badge>;
            } else if (qtyAtHand <= minimumLevel) {
              return <Badge className="me-2 bg-danger">Below Minimum</Badge>;
            } else if (qtyAtHand <= reOrderQty) {
              return <Badge className="me-2 bg-warning">Reorder Needed</Badge>;
            } else {
              return <Badge className="me-2 bg-success">In Stock</Badge>;
            }
        }
        function actionFormatter(cellContent, row){
          return(
            <>
            <Button type="button" color="info" className="btn-sm btn-rounded" onClick={() => { handleClickEdit(row); }}
                > Details</Button>
          </>
          )
        }

        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Inventory | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={url.COMPANY} breadcrumbItem="Inventory" />
                        <Row>
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                    <Row className="justify-content-center mb-1">
                                        <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>From</label>
                                                          <Flatpickr
                                                            className="form-control form-control-sm"
                                                            options={{
                                                                dateFormat: "Y-m-d",
                                                                enableTime: false
                                                            }}
                                                            value={sStartDate}
                                                            onChange={(dates)=>setSStartDate(dates)}
                                                            />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Till </label>
                                                          <Flatpickr
                                                              className="form-control form-control-sm"
                                                              options={{
                                                                  dateFormat: "Y-m-d",
                                                                  enableTime: false
                                                              }}
                                                              value={sEndDate}
                                                              onChange={(dates)=>setSEndDate(dates)}
                                                              />
                                                      </div>
                                                  </Col>
                                    </Row>
                                    <Row className="justify-content-center mb-1">
                                                <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Search by Name</label>
                                                          <input type='text' className="form-control form-control-sm" value={sName} onChange={(e)=>setSName(e.target.value)} />
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                        <div className="mb-3">
                                                            <label>Item Type</label>
                                                            <select className="form-select form-select-sm" value={sItemType} onChange={(e)=>setSItemType(e.target.value)}>
                                                            <option value="">All</option>
                                                            {(typeOptions || []).map((a,k)=>(
                                                            <option key={k} value={a}>{a}</option>
                                                            ))}
                                                            </select>
                                                        </div>
                                                    </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Category</label>
                                                          <select className="form-select form-select-sm" value={sCategoryId} onChange={(e)=>setSCategoryId(e.target.value)}>
                                                          <option value="">All</option>
                                                          {(itemCategoryOptions || []).map((a,k)=>(
                                                            <option key={k} value={a.id}>{a.name}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Supplier</label>
                                                          <select className="form-select form-select-sm" value={sSupplierId} onChange={(e)=>setSSupplierId(e.target.value)}>
                                                          <option value="">All</option>
                                                          {(supplierOptions || []).map((a,k)=>(
                                                            <option key={k} value={a.id}>{a.name}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                 {/*
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Umbrella</label>
                                                          <select className="form-select form-select-sm" value={sRegionId} onChange={(e)=>setSRegionId(e.target.value)}>
                                                          <option value="">All</option>
                                                          {(regionOptions || []).map((a,k)=>(
                                                            <option key={k} value={a.id}>{a.region}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  */}
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Warehouse</label>
                                                          <select className="form-select form-select-sm" value={sWarehouseId} onChange={(e)=>setSWarehouseId(e.target.value)}>
                                                          <option value="">All</option>
                                                          {(warehouseOptions || []).map((a,k)=>(
                                                            <option key={k} value={a.id}>{a.name}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                </Row>
                                       
                                                <Row  className="justify-content-center mb-2 mt-3">
                                                <Col lg={2}> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                 
                                                  <Col lg={2}> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClickAdd()}}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Add Inventory Item
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  
                                                </Row>
                                                </CardBody>
                                                </Card>
                        
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Inventory Items ({inventoryList.length})</h5>
                                <CardBody>

                                
                                <Modal isOpen={modal_inventory} toggle={() => { tog_inventory();}} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit ? 'Edit ': 'Add ' } {' Inventory'}</h5>
                                    <button onClick={() => { setmodal_inventory(false);}} className="close" data-dismiss="modal" aria-label="Close"></button>
                                  </div>
                                  <div className="modal-body">
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Item Name</label>
                                                <input type='text' className="form-control" value={name} onChange={(e)=>setName(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Units</label>
                                                <select className="form-select" value={count} onChange={(e)=>setCount(e.target.value)}>
                                                <option value=""></option>
                                                {(countOptions || []).map((a,k)=>(
                                                    <option key={k} value={a}>{a}</option>
                                                ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Description</label>
                                                <input type='text' className="form-control" value={description} onChange={(e)=>setDescription(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col xl={6}>
                                            <div className="mb-3">
                                                <label>Item Type</label>
                                                <select className="form-select" value={itemType} onChange={(e)=>setItemType(e.target.value)}>
                                                <option value=""></option>
                                                {(typeOptions || []).map((a,k)=>(
                                                <option key={k} value={a}>{a}</option>
                                                ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Category</label>
                                                <select className="form-select" value={categoryId} onChange={(e)=>setCategoryId(e.target.value)}>
                                                <option value=""></option>
                                                {(itemCategoryOptions || []).map((a,k)=>(
                                                    <option key={k} value={a.id}>{a.name}</option>
                                                ))}
                                                </select>
                                            </div>
                                        </Col>
                                     
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>SKU</label>
                                                <input type='text' className="form-control" value={sku} onChange={(e)=>setSKU(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Warehouse</label>
                                                <select className="form-select" value={warehouseId} onChange={(e)=>setWarehouseId(e.target.value)} >
                                                    <option value=""></option>
                                                    {(warehouseOptions || []).map((a,k)=>(
                                                            <option key={k} value={a.id}>{a.name}</option>
                                                          ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Cost Price</label>
                                                <input type='number' className="form-control" value={costPrice} onChange={(e)=>setCostPrice(e.target.value)} />
                                            </div>
                                        </Col>
                                        {/*}
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Sell Price</label>
                                                <input type='text' className="form-control form-control-sm" value={sellPrice} onChange={(e)=>setSellPrice(e.target.value)} />
                                            </div>
                                        </Col>
                                        */}
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Supplier</label>
                                                <select className="form-select" value={supplierId} onChange={(e)=>setSupplierId(e.target.value)} >
                                                    <option value=""></option>
                                                    {(supplierOptions || []).map((a,k)=>(
                                                    <option key={k} value={a.id}>{a.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        
                                        <hr/>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Quantity at Hand</label>
                                                <input type='number' className="form-control" value={qtyAtHand} onChange={(e)=>setQtyAtHand(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Minimum Level</label>
                                                <input type='number' className="form-control" value={minimumLevel} onChange={(e)=>setMinimumLevel(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Re Order Quantity</label>
                                                <input type='number' className="form-control" value={reorderQty} onChange={(e)=>setReorderQty(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Expiry Date</label>
                                                <Flatpickr
                                                    className="form-control"
                                                    options={{
                                                        dateFormat: "Y-m-d",
                                                        enableTime: false
                                                    }}
                                                    value={expiryDate}
                                                    onChange={(dates)=>setExpiryDate(dates)}
                                                    />
                                            </div>
                                        </Col>
                                        {/*<Col md={6}>
                                            <div className="mb-3">
                                                <label>Purchase Price</label>
                                                <input type='text' className="form-control" value={reorderQty} onChange={(e)=>setReorderQty(e.target.value)} />
                                            </div>
                                        </Col>
                                        */}
                                        
                            
                                    </Row>
                                  </div>
                                  
                                  <div className="modal-footer">
                                    {isloading?`Please wait...`:(<>
                                    <button  onClick={() => { tog_inventory(); }} className="btn btn-danger" data-dismiss="modal">Close</button>
                                    <button className="btn btn-success" onClick={handleSaveInventory}>Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                {inventoryList && (inventoryList.length > 0) && (
                                    <>
                                    <ToolkitProvider
                                      keyField="id"
                                      data={inventoryList}
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={inventoryList} 
                                                  columns={ columns } 
                                                  striped
                                                  //hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>

                                    </>
                                )}
                                {inventoryList && (inventoryList.length < 1) && (
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                        </div>
                                        <div>
                                        <h5>No Inventory items Found</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>

                                )}
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default Inventory;